import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription, catchError, tap } from 'rxjs';

import { AcoesEnum } from '@core/enums/acoes.enum';
import { AcoesService } from '@core/services/acoes.service';
import { Combo } from '@core/models/combo';
import { ConverterInterfaceEditalHelper } from '@core/helpers/converter-interface-edital.helper';
import { Edital } from '@core/models/edital';
import { Message } from 'primeng/api';
import { OportunidadesApiService } from '@app/core/services/oportunidades-api.service';
import { Router } from '@angular/router';
import { SituacoesEnum } from '@core/enums/situacoes.enum';
import { UiService } from '@core/services/ui.service';
import { UsuariosService } from '@core/services/usuarios.service';

@Component({
	selector: 'sgp-solicitar-acao',
	templateUrl: './solicitar-acao.component.html'
})
export class SolicitarAcaoComponent implements OnInit, OnDestroy {
	@Input() id!: string;
	@Input() titulo!: string;
	@Input() tipoAcao!: AcoesEnum;
	@Input() edital!: Edital;
	@Input() labelBotaoAcao!: string;
	@Input() showModal = false;
	@Output() fecharModal: EventEmitter<string> = new EventEmitter<string>();
	@Output() editalAtualizado: EventEmitter<Edital> = new EventEmitter<Edital>();
	mensagemFeedback: Message[] = [];

	listaUnidadesAutorizadoras: any[] = [];
	unidadeSelecionada?: Combo;
	textoRetificacao =
		'<p class="ql-align-justify">O <u>(órgão/entidade)</u> retifica o Edital supracitado, conforme alterações a seguir relacionadas:</p><p class="ql-align-justify"> </p><p class="ql-align-justify">O item (Gestor de Oportunidade, informe a identificação do item do edital que será retificado) passa a vigorar nos seguintes termos:</p><p class="ql-align-justify">Gestor de Oportunidade apresente nesta seção as informações atualizadas do item, respeitando a estrutura do edital publicado.</p><p class="ql-align-justify">OU </p><p class="ql-align-justify">O item 1. SOBRE A UNIDADE passa a vigorar nos seguintes termos:</p><p class="ql-align-justify">Gestor de Oportunidade apresente nesta seção as informações atualizadas do item, respeitando a estrutura do edital publicado.</p><p class="ql-align-justify"> </p><p class="ql-align-justify">O item 2. DA(S) VAGA(S) / OPORTUNIDADE(S) passa a vigorar nos seguintes termos:</p><p class="ql-align-justify">2.1 Oportunidade 1</p><p class="ql-align-justify">Gestor de Oportunidade apresente nesta seção as informações atualizadas do item, respeitando a estrutura do edital publicado.</p><p class="ql-align-justify"> </p><p class="ql-align-justify">2.2 Oportunidade 2</p><p class="ql-align-justify">Gestor de Oportunidade apresente nesta seção as informações atualizadas do item, respeitando a estrutura do edital publicado.</p><p class="ql-align-justify"> </p><p class="ql-align-justify">O item 3. DO PROCESSO SELETIVO passa a vigorar nos seguintes termos:</p><p class="ql-align-justify">Gestor de Oportunidade apresente nesta seção as informações atualizadas do item, respeitando a estrutura do edital publicado.</p><p class="ql-align-justify"> </p><p class="ql-align-justify">O item 4. CRONOGRAMA passa a vigorar nos seguintes termos:</p><p class="ql-align-justify">Gestor de Oportunidade apresente nesta seção as informações atualizadas do item, respeitando a estrutura do edital publicado.</p><p class="ql-align-justify"> </p><p class="ql-align-justify">O edital consolidado está disponível no aplicativo SOUGOV.BR, Currículo e Oportunidades.</p><p><br></p>';
	textoResultado = '';
	textoJustificativa = '';
	subscriptions: Subscription[] = [];
	parametros: any;
	erroUnidadeAutorizadora = false;
	erroTextoRetificacao = false;
	erroTextoPublicacaoResultado = false;
	erroJustificativa = false;
	desabilitar = false;
	desabilitarBotaoPreview = false;
	finalizado = false;
	situacaoEdital: any;
	historicoEdital?: any[];
	gerandoPDF = false;
	labelBotaoPreview = 'Preview';

	constructor(
		private acoesService: AcoesService,
		private converterInterfaceEdital: ConverterInterfaceEditalHelper,
		private oportunidadesService: OportunidadesApiService,
		private router: Router,
		private ui: UiService,
		private usuarioService: UsuariosService
	) {}

	ngOnInit() { 
		if (
			this.acoesService.isAcaoSolicitacaoPublicacaoEdital(this.tipoAcao) ||
			this.acoesService.isAcaoSolicitacaoPublicacaoRetificacao(this.tipoAcao)
		) {
			this.obterUnidadesOrganizadoras();
		}
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(subscription => subscription.unsubscribe());
	}

	get acoesEnum(): typeof AcoesEnum {
		return AcoesEnum;
	}

	/**
	 * Limpa os dados e passa para o componente pai o id do modal que deve ser fechado
	 */
	esconderModal() {
		this.erroUnidadeAutorizadora = false;
		this.erroTextoRetificacao = false;
		this.erroTextoPublicacaoResultado = false;
		this.erroJustificativa = false;
		this.unidadeSelecionada = undefined;
		this.textoJustificativa = '';
		this.textoRetificacao = '';
		this.desabilitar = false;
		this.fecharModal.emit(this.id);
		if (this.finalizado) {
			this.encerrarSolicitacao();
		}
	}

	async gerarPdfRetificacao() {
		this.gerandoPDF = true;
		if (this.edital !== undefined) {
			this.labelBotaoPreview = 'Aguarde...';
			this.desabilitarBotaoPreview = true;
			this.subscriptions.push(
				this.oportunidadesService.gerarPdfRetificacao(this.edital.id, this.textoRetificacao).subscribe(
					res => {
						const newBlob = new Blob([res], { type: 'application/pdf' });
						const nav = window.navigator as any;
						if (nav && nav.msSaveOrOpenBlob) {
							nav.msSaveOrOpenBlob(newBlob, 'retificacao.pdf');
							return;
						}
						const data = window.URL.createObjectURL(newBlob);
						const link = document.createElement('a');
						link.href = data;
						link.download = 'retificacao.pdf';
						link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
						setTimeout(function () {
							window.URL.revokeObjectURL(data);
							link.remove();
						}, 100);
						this.gerandoPDF = false;
						this.labelBotaoPreview = 'Preview';
						this.desabilitarBotaoPreview = false;
					},
					err => {
						return err.error.message;
					}
				)
			);
		}
	}

	/**
	 * Chama o serviço de executar ação passando os parâmetros necessários.
	 */
	executarAcao() {
		const labelBotaoAcaoAnterior = this.labelBotaoAcao;
		if (this.validarPreenchimentoCampos()) {
			this.labelBotaoAcao = 'Aguarde...';
			this.desabilitar = true;
			const params = this.acoesService.montarParametrosAcao(
				this.tipoAcao,
				this.unidadeSelecionada?.codigo,
				this.textoRetificacao,
				this.textoJustificativa,
				this.textoResultado
			);
			this.subscriptions.push(
				this.oportunidadesService.executarAcaoEdital(this.edital.id, params).subscribe(
					async res => {
						if (await res) {
							if (
								this.tipoAcao !== this.acoesEnum.OPO_SOLICITAR_PUBLICACAO_RETIFICACAO &&
								this.tipoAcao !== this.acoesEnum.OPO_PUBLICAR_RESULTADO
							) {
								this.converterInterfaceEdital.converter(this.edital, res);
								this.editalAtualizado.emit(this.edital);
							}
							this.labelBotaoAcao = labelBotaoAcaoAnterior;
							this.finalizado = true;
							this.mensagemFeedback = this.ui.criarListaMensagem(
								'success',
								'',
								this.acoesService.mensagemSucessoAcao(this.tipoAcao)
							);
						}
					},
					err => {
						this.labelBotaoAcao = labelBotaoAcaoAnterior;
						this.desabilitar = false;
						this.mensagemFeedback = this.ui.criarListaMensagem('error', '', err.error.message);
					}
				)
			);
		}
	}

	/**
	 * Carrega a lista de unidades organizadoras baseado no perfil do usuário.
	 */
	private obterUnidadesOrganizadoras() {
		this.subscriptions.push(
			this.oportunidadesService
				.unidadesAutorizadoras()
				.pipe(
					tap(unidades => {
						if (unidades) {
							if (unidades.length == 0)
							{
								this.mensagemFeedback = this.ui.criarListaMensagem('error', '', 'Usuário sem Uorg associada ao perfil.');
								return;
							}
							for (const unidade of unidades) {
								this.listaUnidadesAutorizadoras.push({ descricao: unidade.nome, codigo: unidade.codigoSiape });
							}
							if (this.listaUnidadesAutorizadoras.length > 1) {
								this.listaUnidadesAutorizadoras.sort((a, b) => a.descricao.localeCompare(b.descricao));
							}
							this.selecionarUnidadePadrao();
						}
					}),
					catchError(err => {
									this.mensagemFeedback = this.ui.criarListaMensagem('error', '', err.error.message);
									return [this.mensagemFeedback];
					})
				)			
				.subscribe()
		);
	}

	/**
	 * Regra: Se o edital estiver na situação de rascunho, ao solicitar a publicação a unidade padrão deve ser a unidade do usuário.
	 * Se o edital tiver sido publicado, ao solicitar retificação a unidade padrão deve ser a da última solicitação de publicação.
	 */
	private selecionarUnidadePadrao() {
		this.acoesService.sharedSituacaoEdital.subscribe(situacao => (this.situacaoEdital = situacao));
		if (this.situacaoEdital.codigo === SituacoesEnum.RAS) {
			const codigoUorg = this.usuarioService.getCodigoUnidadeUsuario();
			this.unidadeSelecionada = this.listaUnidadesAutorizadoras.find(x => x.codigo.toString() == codigoUorg);
		} else if (this.situacaoEdital.codigo === SituacoesEnum.RET) {
			this.acoesService.sharedHistoricoEdital.subscribe(historico => (this.historicoEdital = historico));
			if (this.historicoEdital) {
				const itensHistorico = this.historicoEdital.filter(x => x.situacao!.codigo == SituacoesEnum.PSO);
				const ultimaPublicacaoSolicitada = itensHistorico[itensHistorico.length - 1];
				this.unidadeSelecionada = this.listaUnidadesAutorizadoras.find(
					x => x.codigo.toString() == ultimaPublicacaoSolicitada.codigoUnidadeAutorizadora
				);
			}
		}
	}

	/**
	 * Se a solicitação for de publicação, de retificação e publicação de resultado, redireciona para a página do edital ao fechar o modal.
	 */
	private encerrarSolicitacao() {
		if (
			this.acoesService.isAcaoSolicitacaoPublicacaoEdital(this.tipoAcao) ||
			this.acoesService.isAcaoSolicitacaoPublicacaoRetificacao(this.tipoAcao) ||
			this.acoesService.isAcaoPublicarResultado(this.tipoAcao)
		) {
			this.router.navigate(['/edital', this.edital.id]);
		}
	}

	/**
	 * Valida o preenchimento de campos de acordo com o tipo de ação
	 */
	private validarPreenchimentoCampos(): boolean {
		if (this.acoesService.isAcaoSolicitacaoPublicacaoEdital(this.tipoAcao)) {
			return this.validarPreenchimentoUnidade();
		}
		if (this.acoesService.isAcaoSolicitacaoPublicacaoRetificacao(this.tipoAcao)) {
			this.validarPreenchimentoUnidade();
			return this.validarPreenchimentoTextoRetificacao();
		}
		if (this.acoesService.isAcaoPublicarResultado(this.tipoAcao)) {
			return this.validarPreenchimentoTextoResultado();
		}
		if (
			this.acoesService.isAcaoRejeicao(this.tipoAcao) ||
			this.acoesService.isAcaoSuspenderEdital(this.tipoAcao) ||
			this.acoesService.isAcaoEncerrarEdital(this.tipoAcao)
		) {
			return this.validarPreenchimentoJustificativa();
		}
		return true;
	}

	private validarPreenchimentoUnidade(): boolean {
		if (this.unidadeSelecionada == undefined) {
			this.erroUnidadeAutorizadora = true;
			return false;
		}
		this.erroUnidadeAutorizadora = false;
		return true;
	}

	private validarPreenchimentoTextoRetificacao(): boolean {
		if (this.textoRetificacao == undefined || this.textoRetificacao == '') {
			this.erroTextoRetificacao = true;
			return false;
		}
		this.erroTextoRetificacao = false;
		return true;
	}

	private validarPreenchimentoTextoResultado(): boolean {
		if (this.textoResultado == undefined || this.textoResultado == '') {
			this.erroTextoPublicacaoResultado = true;
			return false;
		}
		this.erroTextoPublicacaoResultado = false;
		return true;
	}

	private validarPreenchimentoJustificativa(): boolean {
		if (this.textoJustificativa == undefined || this.textoJustificativa == '') {
			this.erroJustificativa = true;
			return false;
		}
		this.erroJustificativa = false;
		return true;
	}
}
